import React from 'react';

import { Copy } from 'lucide-react';
import { Toast } from 'src/common/components';

type Props = {
  code: string;
};

/** An invite code chip with a copy button. Shared by the codes and waitlist
 * tables so the two can't drift on styling or on the accessible name — a table
 * of buttons all called "Copy code" is unusable with a screen reader, so the
 * label always carries the code itself. */
export const CopyableCode: React.FC<Props> = ({ code }) => {
  const handleCopy = (): void => {
    navigator.clipboard
      .writeText(code)
      .then(() => Toast.success('Code copied.'))
      .catch(() => Toast.error('Could not copy.'));
  };

  return (
    <span className="flex items-center gap-1.5">
      <span className="bg-gray-100 text-gray-800 font-mono px-2 py-0.5 rounded text-xs">
        {code}
      </span>
      <button
        type="button"
        onClick={handleCopy}
        className="hover:text-gray-600 text-gray-400"
        aria-label={`Copy code ${code}`}
      >
        <Copy size={13} />
      </button>
    </span>
  );
};
